import b64toBlob from '../../../../utils/b64toBlob';
import { GLOBAL_EVENT_ANIM, ObserverAnim } from '../../Observer';
import { propEq, find, findIndex } from 'ramda';
import { AddAnimationPayloadInterface } from '../../../../Redux/Actions/Animator/animation.list.action';

export default class RenderAnimationScene extends Phaser.Scene {
    // El nombre por defecto del atlas
    name_atlas: string = '';

    animate_atlas!: Phaser.GameObjects.Sprite;
    // El nombre de la animación por defecto (solo hay una en esta versión)
    animation_name = 'default_tool_animation';
    // Animación actual (para setear la animación)
    actual_animation!: any;

    // Esto nos ayuda a enviar el frame que se está ejecutando actualmente
    actual_frame = '0';

    // Pintamos la imagen para mostrar que no se puede animar
    tint = 0xff0000;

    constructor() {
        super({ key: 'RenderAnimationScene' });
    }

    init() {
        this.registry.events.on(GLOBAL_EVENT_ANIM.RENDER.SET_ZOOM, (zoom_size: number) => {
            this.scale.setZoom(zoom_size);
            this.scale.refresh();
            this.scale.updateScale();
        });
    }

    preload() {
        this.load.image('empty_frame', './assets/canvas-background.png');
    }

    create() {
        this.registry.events.once(GLOBAL_EVENT_ANIM.RENDER.IMPORT_ATLAS, (atlas_object: any) => {
            this.name_atlas = atlas_object.image.name;
            this.load.atlas(
                atlas_object.image.name,
                URL.createObjectURL(b64toBlob(atlas_object.image.src)),
                JSON.parse(atlas_object.json)
            );
            this.load.start();
        });
        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            // Configurar el tamaño máximo del lienzo
            this.setCanvasSize();
            this.animate_atlas = this.add
                .sprite(this.scale.width / 2, this.scale.height / 2, this.name_atlas)
                .setTint(this.tint);
        });

        // Se agrega o cambia animación actual
        this.registry.events.on(
            GLOBAL_EVENT_ANIM.RENDER.CHANGE_OR_CREATE_ANIMATION_CONTAINER,
            (animation_in: any) => {
                const actual_animation = find(
                    propEq('id', animation_in.actual_animation),
                    animation_in.animations
                ) as AddAnimationPayloadInterface;
                // Comprobamos si se ha creado una animación o no
                if (actual_animation !== undefined) {
                    this.create_animation(actual_animation);
                    if (actual_animation.frames.length < 1) {
                    }
                }
            }
        );

        this.registry.events.on(
            GLOBAL_EVENT_ANIM.RENDER.ADD_OR_REMOVE_FRAME_TO_ANIMATION_CONTAINER,
            (animation_in: any) => {
                const actual_animation = find(
                    propEq('id', animation_in.actual_animation),
                    animation_in.animations
                );
                if (actual_animation !== undefined) {
                    this.create_animation(actual_animation);
                }
            }
        );

        // Observadores:
        this.registry.events.on(GLOBAL_EVENT_ANIM.PLAY_STOP_CONTROL, (state: boolean) => {
            if (!state) {
                this.animate_atlas.anims.play(this.animation_name);
            } else {
                this.animate_atlas.anims.stop();
            }
        });
    }

    create_animation(animation_in: any) {
        this.animate_atlas.anims.stop();
        const frames_name =
            animation_in !== undefined ? animation_in.frames.map((frame: any) => frame.name) : [];

        const frames = this.anims.generateFrameNames(this.name_atlas, {
            frames: frames_name,
        });

        this.anims.remove(this.animation_name);
        this.anims.create({
            key: this.animation_name,
            frameRate: Number(animation_in.key_controls.frame_rate),
            repeat: Number(animation_in.key_controls.repeat),
            frames: frames,
        });

        this.actual_animation = this.anims.get(this.animation_name);

        if (animation_in.play) {
            this.animate_atlas.anims.play(this.animation_name);
        }

        if (this.actual_animation.frames.length >= 1) {
            const frame_active_index = findIndex(propEq('active', true), animation_in.frames);
            const verify_active_index = frame_active_index !== -1 ? frame_active_index : 0;

            const newTexture = this.actual_animation.frames[verify_active_index].textureFrame;
            this.animate_atlas.setTexture(this.name_atlas, newTexture);
            this.animate_atlas.clearTint();
        } else {
            this.animate_atlas.setTint(this.tint);
        }
    }

    setCanvasSize() {
        const texturesKeys = Object.keys(this.textures.get(this.name_atlas).frames);
        const size = texturesKeys.reduce(
            (prev: any, current: any) => {
                const actual_frame = this.textures.getFrame(this.name_atlas, current);
                let output = prev;
                if (current !== '__BASE') {
                    output = {
                        width: prev.width < actual_frame.width ? actual_frame.width : prev.width,
                        height:
                            prev.height < actual_frame.height ? actual_frame.height : prev.height,
                    };
                }
                return output;
            },
            { width: 0, height: 0 }
        );
        this.scale.resize(size.width + 40, size.height + 40);
    }

    update() {
        if (this.animate_atlas !== undefined) {
            if (
                this.animate_atlas.anims.isPlaying &&
                this.actual_frame !== this.animate_atlas.frame.name
            ) {
                this.actual_frame = this.animate_atlas.frame.name;
                const current_frame = this.animate_atlas.anims.currentFrame;
                // Enviamos el ID generado por el current frame name y el index
                const id_to_frame = `${current_frame.textureFrame}_${current_frame.index}`;
                ObserverAnim.emit(GLOBAL_EVENT_ANIM.RENDER.UPDATE_FRAMES, id_to_frame);
            }
        }
    }
}
